import React, { useEffect, useState } from "react";
import {
  ContentFilters,
  ContentHeaderMyGames,
  GeneralMyGames,
  HR,
  TitleMyGames,
  DateContainer,
  LeftContent,
  RightContent,
  SearchField,
  CenterContent,
  useStyles,
} from "./MyGamesContainer.styled";
import MyGames from "../../components/MyGames/MyGames";
import { Row, Form } from "react-bootstrap";
import { theme as themeConfig } from "../../themes/themes";
import { useLazyQuery } from "@apollo/client";
import { MY_GAMES } from "../../GraphQL/Queries";
import { clientWellness } from "../../App";
import SearchIcon from "@material-ui/icons/Search";
import { useHistory } from "react-router-dom";
import TablePagination from "@material-ui/core/TablePagination";
import { ReactComponent as GamificationIcon } from "../../assets/svg/gamification-header-icon.svg";
import HeaderComponent from "../../components/Header/Header";

const MyGamesContainer = () => {
  const classes = useStyles();
  const history = useHistory();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [myGames, setMyGames] = useState([]);
  const [backupgames, setBackupGames] = useState([]);
  const [initialDate, setInitialDate] = useState(new Date());
  const [endDate, setEndDate] = useState(() => {
    let futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + 10000);
    return futureDate;
  });
  const [searchTxt, setSearchTxt] = useState("");
  const rowsPerPageList = [5, 10, 20];
  const [currentPage, setCurrentPage] = useState(0);
  const [gamesList, setGamesList] = useState([]);

  const [runQueryMyGames, { loading: loadingMyGames, error: errorMyGames }] =
    useLazyQuery(MY_GAMES, {
      client: clientWellness,
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let mygamesActiveList = data?.myGames?.nodes.filter(
          (game) => game.status !== "Inactive"
        );
        setMyGames(mygamesActiveList);
        setBackupGames(mygamesActiveList);
      },
    });

  let filterMyGames = () => {
    let gamesList = backupgames.filter((game) => {
      let searchTxtMatch = false;
      if (searchTxt !== "") {
        if (
          JSON.stringify(game)
            .toLowerCase()
            .indexOf(searchTxt.toLowerCase()) !== -1
        ) {
          searchTxtMatch = true;
        }
      } else {
        searchTxtMatch = true;
      }
      if (
        new Date(game.endDate) >= new Date(initialDate) &&
        new Date(game.endDate) <= new Date(endDate)
      ) {
        return searchTxtMatch;
      } else {
        return false;
      }
    });
    setMyGames(gamesList);
  };

  useEffect(() => {
    let startIndex = rowsPerPage * currentPage;
    setGamesList(myGames.slice(startIndex, startIndex + rowsPerPage));
  }, [rowsPerPage, myGames, currentPage]);

  useEffect(() => {
    runQueryMyGames({
      variables: {
        initialDate: new Date(initialDate),
        finalDate: new Date(endDate),
        searchBy: "",
      },
    });
  }, []);

  useEffect(() => {
    filterMyGames();
  }, [searchTxt]);

  let goToDetail = (myspace) => {
    setTimeout(() => {
      history.push({ pathname: "/DetailGame", state: { url: myspace.url } });
    }, 0);
  };

  return (
    <GeneralMyGames>
      <HeaderComponent
        Icon={GamificationIcon}
        text={"Gamification"}
        notIncludeHeight={true}
      />
      <Row className={classes.contentForMySpaces}>
        <div className={"ml-4 mt-4 mb-3"} style={{ width: "98%" }}>
          <ContentHeaderMyGames>
            <TitleMyGames>My Games</TitleMyGames>{" "}
          </ContentHeaderMyGames>
        </div>
        <ContentFilters>
          <LeftContent>
            <DateContainer>
              <Form.Label style={{ color: themeConfig.primary.icon }}>Initial Date</Form.Label>{" "}
              <Form.Control
                type="date"
                required={false}
                value={initialDate}
                onChange={(e) => {
                  setInitialDate(e.target.value);
                }}
                onBlur={() => filterMyGames()}
              />
            </DateContainer>
          </LeftContent>
          <CenterContent>
            <DateContainer>
              <Form.Label style={{ color: themeConfig.primary.icon }}>Final Date</Form.Label>{" "}
              <Form.Control
                type="date"
                required={false}
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
                onBlur={() => filterMyGames()}
              />
            </DateContainer>
          </CenterContent>
          <RightContent>
            <Form.Label style={{ color: themeConfig.primary.icon }}>Search</Form.Label>{" "}
            <SearchField>
              <SearchIcon />
              <Form.Control
                type="text"
                placeholder="Search"
                value={searchTxt}
                onChange={(e) => {
                  setSearchTxt(e.target.value);
                }}
              />
            </SearchField>
          </RightContent>
        </ContentFilters>
        <HR style={{ marginTop: "10px" }} />
        <MyGames
          loadingMySpacesFirst={loadingMyGames}
          errorMySpacesFirst={errorMyGames}
          myGames={gamesList}
          rowsPerPage={rowsPerPage}
          goToDetail={goToDetail}
        />

        {gamesList.length > 0 ? (
          <TablePagination
            component="div"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "6em",
            }}
            count={myGames.length}
            page={currentPage}
            onPageChange={(e, newPage) => {
              setCurrentPage(newPage);
            }}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={rowsPerPageList}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(
                parseInt(event?.target?.value ? event?.target?.value : "5")
              );
              setCurrentPage(0);
            }}
          />
        ) : (
          <></>
        )}
      </Row>
    </GeneralMyGames>
  );
};

export default MyGamesContainer;
